import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  links: PropTypes.arrayOf(PropTypes.element).isRequired,
  align: PropTypes.oneOf(['', 'center']),
  theme: PropTypes.oneOf(['', 'inverse'])
};
function PipeDelimitedLinks(_ref) {
  var align = _ref.align,
    links = _ref.links,
    theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pipe-delimited-links",
    "data-align": align,
    "data-testid": "pipe-delimited-links",
    "data-theme": theme
  }, /*#__PURE__*/React__default.createElement("ul", null, links.map(function (link) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "pipe-delimited-link",
      key: link.key || link.props.href
    }, link);
  })));
}
PipeDelimitedLinks.propTypes = propTypes;

export { PipeDelimitedLinks as default };
//# sourceMappingURL=PipeDelimitedLinks.js.map
